const navigation = {
  welcome: 'Dobrodošli',
  rooms: 'Sobe',
  dining: 'Restoran',
  promotions: 'Promocije',
  shanghai: 'Shanghai Restaurant',
  lavilla: 'LaVilla Restaurant',
  footer: 'Kontakt',
};

export default navigation;